import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { PreviewService } from 'src/sb-modules/Frontend-Document-Viewer-Module/services/preview.service';
import { ImageAttachment } from 'src/sb-modules/Frontend-Document-Viewer-Module/models/image-attachment.model';

interface ImageElementWithIndex extends HTMLElement {
    index: number;
}

@Directive({
    selector: '[sbInlineImagePreview]',
})
export class InlineImagePreviewDirective implements OnChanges, AfterViewInit, OnDestroy {
    @Input() updateStamp?: number;
    @Input() isEnablePostMessages?: boolean;
    @Input() isEnablePostMessageForWidget: boolean;

    private imageAttachments: ImageAttachment[] = [];
    private imageElements: ImageElementWithIndex[] = [];

    constructor(
        private element: ElementRef,
        private previewService: PreviewService,
    ) {
        this.openImagePreview = this.openImagePreview.bind(this);
    }

    ngOnChanges(): void {
        if (this.updateStamp) {
            this.removeImageListeners();
            this.initImagePreviewListeners();
        }
    }

    ngAfterViewInit(): void {
        this.initImagePreviewListeners();
    }

    private initImagePreviewListeners(): void {
        this.imageElements = this.element.nativeElement.querySelectorAll('img');
        this.imageAttachments = this.previewService.getImageAttachmentList(this.imageElements);

        this.imageElements.forEach((image: ImageElementWithIndex, index) => {
            image.index = index;
            image.addEventListener('click', this.openImagePreview);
        });
    }

    private openImagePreview(event): void {
        this.previewService.openImagePreview(
            this.imageAttachments,
            event.currentTarget.index,
            this.isEnablePostMessages,
            this.isEnablePostMessageForWidget,
        );
    }

    private removeImageListeners(): void {
        this.imageElements.forEach((image: HTMLElement) => {
            image.removeEventListener('click', this.openImagePreview);
        });
    }

    ngOnDestroy(): void {
        this.removeImageListeners();
    }
}
